import Vue from 'vue'
import Vuex from 'vuex'
// chamadas a API
import requests from "../requests/index";
// constantes do sistema
import constants from "../constants/index";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        requests: requests,
        constants: constants,
        msgs: [],
        token: null,
        nome: '',
        nuped: '',
        listaPedidos: [],
        listaExames: [],
        pedidoSelecionado: null
    },
    mutations: {
        registraToken(state, token) {
            Vue.set(state, 'token', token)
        },
        registraPedidos(state, pedidos) {
            state.listaPedidos = pedidos
        },
        registraExames(state, exames) {
            state.listaExames = exames
        },
        registraNome(state, nome) {
            state.nome = nome
        },
        registraNuped(state, nuped) {
            state.nuped = nuped
        },
        registraPedido(state, pedido) {
            state.pedidoSelecionado = pedido
        },
        limpaPedido(state) {
            state.pedidoSelecionado = null
        },
        limpaExames(state) {
            state.listaExames = []
        },
        limpaDados(state) {
            state.nome  = ""
            state.nuped = ""
            state.listaPedidos = []
            state.listaExames = []
            state.pedidoSelecionado = null
        },

    },
    actions: {
        gravaToken({ commit }, token) {
            commit('registraToken', token)
        },
        gravaListaPedidos({ commit }, pedidos) {
            commit('registraPedidos', pedidos)
        },
        gravaListaExames({ commit }, exames) {
            commit('registraExames', exames)
        },
        gravaDadosForm({ commit }, {nome, nuped}) {
            commit('registraNome', nome)
            commit('registraNuped', nuped)
        },
        selecionaPedido({ commit }, pedido) {
            commit('registraPedido', pedido)
        },
        desselecionaPedido({ commit }) {
            commit('limpaPedido')
            commit('limpaExames')
        },
        flushDados({ commit }) {
            commit('limpaDados')
        }
    },
    getters: {
        http: state => state.requests, 
        const: state => state.constants,
        token: state => state.token,
        nome: state => state.nome,
        nuped: state => state.nuped,
        pedidos: state => state.listaPedidos,
        exames: state => state.listaExames,
        pedidoSel: state => state.pedidoSelecionado,
    }
})
